import styled from 'styled-components'
import Link from '../Link'

function ArticleCta( { cta } ) {
  if ( !cta.ctaLinkUrl || !cta.ctaLinkText ) {
    return null
  }
  
  return (
    <Link
      href={ cta.ctaLinkUrl }
    >
      <StyledArticleCta>
        <h2>{ cta.ctaTitle }</h2>
        <p>{ cta.ctaLinkText }</p>
      </StyledArticleCta>
    </Link>
  )
}

const StyledArticleCta = styled.div`
  padding: 1rem 1rem 1.5rem;
  background: ${ p => p.theme.colors.black };

  h2 {
    margin: 0;
    ${ p => p.theme.typo.generalSansSemiBold }
    font-size: ${ p => p.theme.typo.sizes.normal };
    color: ${ p => p.theme.colors.red };
  }

  p {
    margin: 0;
    margin-top: 1rem;
    color: ${ p => p.theme.colors.white };
    text-decoration: underline;
    text-decoration-thickness: 1px;
  }
`

export default ArticleCta
